import { withInternetuLegacySlugs } from '@/lib/calculatorSlugs.mjs';

/** Construction / special machinery (CPM) calculator landings share one quote flow. */
export const SPECIAL_MACHINERY_INSURANCE_SLUG =
  'spec-transporto-draudimas-internetu';
export const AGRICULTURAL_TECH_INSURANCE_SLUG =
  'zemes-ukio-technikos-draudimas-internetu';

const SPECIAL_MACHINERY_FLOW_SLUGS = withInternetuLegacySlugs([
  SPECIAL_MACHINERY_INSURANCE_SLUG,
  AGRICULTURAL_TECH_INSURANCE_SLUG,
]);

export function isSpecialMachineryInsuranceSlug(slug) {
  return SPECIAL_MACHINERY_FLOW_SLUGS.has(slug);
}

export function isSpecialMachineryInsuranceType(type) {
  return type === 'cpm';
}

export function isSpecialMachineryInsuranceFlow({ slug, type } = {}) {
  return (
    isSpecialMachineryInsuranceType(type) ||
    isSpecialMachineryInsuranceSlug(slug)
  );
}
